import React from 'react';
import { BorrowerList } from '../components/BorrowerList';
export function Dashboard() {
  return <div className="min-h-screen bg-gray-50" data-id="element-307">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10" data-id="element-308">
        {/* Page Header */}
        <div className="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-309">
          <div data-id="element-310">
            <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-311">
              Division Performance Dashboard
            </h1>
            <p className="text-gray-500 mt-1 text-base" data-id="element-312">
              Managerial view across all divisions
            </p>
          </div>
          <div className="flex items-center gap-2.5 text-sm bg-white px-4 py-2.5 rounded-lg border border-gray-200 shadow-sm text-gray-600 whitespace-nowrap" data-id="element-313">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse flex-shrink-0" data-id="element-314" />
            Market rates dropped 0.125% today
          </div>
        </div>

        {/* Accordion Table with embedded summary tiles */}
        <BorrowerList data-id="element-315" />
      </main>
    </div>;
}